import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PageModelInitialState as initialState } from './initial-state';
import { ModelJson } from './types';
import { useActions as useDispatchActionHook } from '../../common/hooks';
import { getNetworkState, NetworkError, NetworkStatuses } from '../network';

export const PageModelSlice = createSlice({
	name: 'pageModel',
	initialState,
	reducers: {
		pageModelFetchRequest(state) {
			state.network = getNetworkState(NetworkStatuses.REQUEST);
		},
		pageModelFetchSuccess(state, action: PayloadAction<{ data: ModelJson }>) {
			const { data } = action.payload;
			state.data = data;
			state.network = getNetworkState(NetworkStatuses.SUCCESS);
		},
		pageModelFetchFailed(state, action: PayloadAction<{ error: NetworkError }>) {
			const { error } = action.payload;
			state.network = getNetworkState(NetworkStatuses.FAILED, error);
		},
	},
});

export const {
	pageModelFetchRequest,
	pageModelFetchSuccess,
	pageModelFetchFailed,
} = PageModelSlice.actions;

export const {
	name: pageModelName,
	reducer: pageModelReducer,
	actions: pageModelActions,
} = PageModelSlice;
export const useDispatchPageModelAction = () => useDispatchActionHook(pageModelActions);
